<template>
  <div class="content">
    <section class="page-intro">
      <p><span class="f-ticker">Email</span></p>
      <p class="tag-list">
        <span class="tag">hello@mattermill.com</span>
      </p>
    </section>
    <section id="contact">
      <div class="row">
        <div class="column column-50">
          <h2 class="mt-0">
            Let's start a project. Availability:<br />—{{ next_month }}
            {{ current_year }}
          </h2>
          <p class="mb-1">
            I typically respond within 1-2 business days. Since I'm often
            working a few projects at a time, I don't usually take on quick
            fixes. If you're unsure where your project falls, fill out the form
            anyway — we'll figure it out.
          </p>
          <form
            action="https://usebasin.com/f/750a8116c08d"
            method="POST"
            enctype="multipart/form-data"
            data-basin-form
            data-basin-success-id="contact-success"
            data-basin-error-id="contact-error"
            data-basin-success-action="render"
            data-basin-spam-protection="recaptcha"
            id="contact-form"
          >
            <fieldset>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Name"
                required
                data-1p-ignore
                data-lpignore="true"
                data-protonpass-ignore="true"
              />
            </fieldset>
            <fieldset>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email"
                required
                data-1p-ignore
                data-lpignore="true"
                data-protonpass-ignore="true"
              />
            </fieldset>
            <fieldset>
              <textarea
                id="message"
                name="message"
                placeholder="Message"
                required
                minlength="10"
                data-1p-ignore
                data-lpignore="true"
                data-protonpass-ignore="true"
              ></textarea>
            </fieldset>
            <button type="submit">Send</button>
          </form>

          <!-- Basin.js success/error divs with specific IDs -->
          <div id="contact-success" style="display: none">
            <div class="success-message">
              Thanks for reaching out. I'll get back to you within 1-2 business
              days.
            </div>
          </div>
          <div id="contact-error" style="display: none">
            <div class="error-message">
              ❌ Oops! Something went wrong. Please try again or email me
              directly at hello@mattermill.com
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="socials">
      <div class="row">
        <div class="column">
          <h2 class="mt-0 mb-1">Elsewhere</h2>
          <div class="social-grid full-bleed">
            <a
              class="grid-item"
              href="https://bsky.app/profile/mattermill.com"
              target="_blank"
            >
              <i class="icon bsky"></i>
              <span>Bluesky</span>
            </a>
            <a
              class="grid-item"
              href="https://www.are.na/matt-miller-kpohjhfw_cm/channels"
              target="_blank"
            >
              <i class="icon arena"></i>
              <span>Are.na</span>
            </a>
            <a
              class="grid-item"
              href="https://github.com/mattermill"
              target="_blank"
            >
              <i class="icon github"></i>
              <span>Github</span>
            </a>
            <a
              class="grid-item"
              href="https://www.instagram.com/mattermill/"
              target="_blank"
            >
              <i class="icon instagram"></i>
              <span>Instagram</span>
            </a>

            <a
              class="grid-item"
              href="https://www.linkedin.com/in/mattermill/"
              target="_blank"
            >
              <i class="icon linkedin"></i>
              <span>LinkedIn</span>
            </a>

            <a
              class="grid-item"
              href="https://open.spotify.com/user/mtthwmllr"
              target="_blank"
            >
              <i class="icon spotify"></i>
              <span>Spotify</span>
            </a>
            <a
              class="grid-item"
              href="https://twitter.com/mattermill"
              target="_blank"
            >
              <i class="icon twitter"></i>
              <span>Twitter</span>
            </a>
            <div class="grid-item"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped lang="scss">
.social-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-bottom: 1px solid var(--color-border-light);

  .grid-item {
    border-top: 1px solid var(--color-border-light);
    padding: 1rem;
    text-decoration: none;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (min-width: 40rem) {
      border-right: 1px solid var(--color-border-light);
    }

    &:hover {
      color: white;
      text-decoration: underline;
    }

    .icon {
      display: inline-block;
      width: 3rem;
      height: 3rem;
      margin-bottom: 0.5rem;

      &.bsky {
        background: url("@/assets/icons/bsky.svg") no-repeat center center;
        background-size: contain;
      }

      &.arena {
        background: url("@/assets/icons/arena.svg") no-repeat center center;
        background-size: contain;
      }

      &.instagram {
        background: url("@/assets/icons/instagram.svg") no-repeat center center;
        background-size: contain;
      }
      &.linkedin {
        background: url("@/assets/icons/linkedin.svg") no-repeat center center;
        background-size: contain;
      }
      &.twitter {
        background: url("@/assets/icons/twitter.svg") no-repeat center center;
        background-size: contain;
      }
      &.spotify {
        background: url("@/assets/icons/spotify.svg") no-repeat center center;
        background-size: contain;
      }
      &.github {
        background: url("@/assets/icons/github.svg") no-repeat center center;
        background-size: contain;
      }
    }
  }
}
#contact {
  padding-bottom: 0;
}
#contact-form {
  input,
  fieldset,
  textarea,
  button {
    margin-bottom: 0;
    border-left: none;
    border-right: none;
    border-bottom: none;
  }

  button {
    width: 100%;
  }

  @media (min-width: 40rem) {
    margin: 0 -1rem;
  }
  @media (max-width: 40rem) {
    input,
    fieldset,
    textarea {
      padding-left: 0;
      padding-right: 0;
    }
    margin-bottom: 1rem;
  }
}
// Form validation styles
.error {
  border-color: #e74c3c !important;
  box-shadow: 0 0 0 2px rgba(231, 76, 60, 0.2) !important;
}

.error-message {
  color: #e74c3c;
  margin-top: 0.25rem;
  margin-bottom: 0.5rem;
}

.success-message {
  color: #27ae60;
  margin-left: -1rem;
  margin-right: -1rem;
  padding: 2rem 1rem;
  background-color: rgba(39, 174, 96, 0.1);
}

.w-form-fail .error-message {
  margin-top: 1rem;
  padding: 1rem;
  background-color: rgba(231, 76, 60, 0.1);
  border: 1px solid rgba(231, 76, 60, 0.3);
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
<script setup>
import { computed, reactive, ref, onMounted, onUnmounted } from "vue";

// Form data
const form = reactive({
  name: "",
  email: "",
  message: "",
});

// Error states
const errors = reactive({
  name: "",
  email: "",
  message: "",
});

// Submission state
const isSubmitting = ref(false);
// Basin.js event handlers
const handleBasinSubmitted = () => {
  // console.log("Form submitted:", event.detail.form);
  isSubmitting.value = true;
};

const handleBasinSuccess = () => {
  // console.log("Form submission succeeded:", event.detail.form);
  isSubmitting.value = false;

  // Reset form on success
  form.name = "";
  form.email = "";
  form.message = "";
  errors.name = "";
  errors.email = "";
  errors.message = "";
};

const handleBasinError = () => {
  // console.error("Form submission error:", event.detail.error);
  isSubmitting.value = false;
};

// Load Basin.js script and set up event listeners
onMounted(() => {
  // Load Basin.js script
  const script = document.createElement("script");
  script.src = "https://js.usebasin.com/v2.8.0.min.js";
  script.defer = true;
  document.head.appendChild(script);

  // Add Basin.js event listeners
  document.addEventListener("basinjsFormSubmitted", handleBasinSubmitted);
  document.addEventListener("basinjsFormSuccess", handleBasinSuccess);
  document.addEventListener("basinjsFormError", handleBasinError);
});

// Clean up event listeners
onUnmounted(() => {
  document.removeEventListener("basinjsFormSubmitted", handleBasinSubmitted);
  document.removeEventListener("basinjsFormSuccess", handleBasinSuccess);
  document.removeEventListener("basinjsFormError", handleBasinError);
});

// Calculate next month and year
const next_month = computed(() => {
  const now = new Date();
  const currentMonth = now.getMonth();
  const nextMonthIndex = (currentMonth + 1) % 12;
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  return monthNames[nextMonthIndex];
});

const current_year = computed(() => {
  const now = new Date();
  const currentMonth = now.getMonth();
  // If current month is December (11), use next year
  return currentMonth === 11 ? now.getFullYear() + 1 : now.getFullYear();
});
</script>
